export const useUrlParams = () => {
  const path = window.location.pathname;
  const parts = path.split('/');
  const roomNumber = parts[parts.length - 1];
  return { roomNumber };
};
